export default "__VITE_ASSET__CR72XrKc__"